import React, { useContext } from 'react';
import clsx from 'clsx';
import Error from '../../../styles/staticAssets/images/Error.svg';
import { ButtonComp } from '../../../atoms/Buttons';
import ImageComponent from '../../../atoms/Image';
import SEARCH_STORE_CONSTANTS from '../Constants/SearchStoreConstants';
import START_ORDER_CONSTANTS from '../../StartOrderComponent/Constants/startOrderConstants';
import { UserOrderContext } from '../../../context/context';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';

const NegativeScenarioErros = props => {
  const { errorMsgToShow, onClearTextHandler, dispositionType, onRetryClickHandler, onMapClickHandler, showMap } =
    props;
  const { userOrderStateDispatch } = useContext(UserOrderContext);
  const { DISPOSITION_METHOD } = START_ORDER_CONSTANTS;
  const {
    DELIVERY_UNAVAILABLE_WITH_CTA,
    TAKE_AWAY,
    TYPE_TAKE_WAY,
    RETRY_TEXT,
    CTA1_SEARCH_DIFF_ADDRESS,
    CTA2_ORDER_TAKEAWAY,
    CTA2_VIEW_MAP_BUTTON_TEXT,
  } = SEARCH_STORE_CONSTANTS;

  const searchDifferentAddress = e => {
    e.preventDefault();
    onClearTextHandler();
  };
  const orderTakeawayHandler = e => {
    e.preventDefault();
    //RENDEV-10899 variable name corrected from TAKE_WAY to TYPE_TAKE_WAY
    userOrderStateDispatch({ type: DISPOSITION_METHOD, value: { dispositionType: TYPE_TAKE_WAY } });
  };
  const locationErrorCls = clsx({
    'error-alert-location-popup': true,
    'error-alert-location-popup-with-map-view': showMap,
  });
  return (
    <React.Fragment>
      <div
        data-testid='alert-locationid'
        className={dispositionType === 'Delivery' ? locationErrorCls : 'error-alert-location-popup error-adjust'}
      >
        <ImageComponent srcFile={Error} className='location-alert-icon' />
        {errorMsgToShow !== DELIVERY_UNAVAILABLE_WITH_CTA && (
          <>
            <div className='location-error-address'>{translateWithI18Next(errorMsgToShow)}</div>
            <div className='location-error-button-section'>
              <ButtonComp
                data-testid='btn-searchDifferentAddressClick'
                className='button whiteButton blackBorder location-warning-button mr'
                onClickHandler={e => searchDifferentAddress(e)}
              >
                {translateWithI18Next(CTA1_SEARCH_DIFF_ADDRESS)}
              </ButtonComp>
              {dispositionType.toLowerCase() !== TAKE_AWAY.toLowerCase() && (
                <ButtonComp
                  data-testid='btn-orderTakeawayClick'
                  className='button whiteButton blackBorder location-warning-button ml'
                  onClickHandler={e => orderTakeawayHandler(e)}
                >
                  {translateWithI18Next(CTA2_ORDER_TAKEAWAY)}
                </ButtonComp>
              )}
            </div>
          </>
        )}
        {errorMsgToShow === DELIVERY_UNAVAILABLE_WITH_CTA && (
          <>
            <div className='location-error-address'>{translateWithI18Next(errorMsgToShow)}</div>
            <div className='location-error-button-section'>
              <ButtonComp
                data-testid='btn-onRetryClick'
                className='button whiteButton blackBorder location-warning-button mr retrybtn'
                onClickHandler={e => onRetryClickHandler(e)}
              >
                {translateWithI18Next(RETRY_TEXT)}
              </ButtonComp>
              {dispositionType !== TAKE_AWAY && (
                <ButtonComp
                  data-testid='btn-onMapClick'
                  className='button whiteButton blackBorder location-warning-button ml retrybtn'
                  onClickHandler={e => onMapClickHandler(e)}
                >
                  {translateWithI18Next(CTA2_VIEW_MAP_BUTTON_TEXT)}
                </ButtonComp>
              )}
            </div>
          </>
        )}
      </div>
    </React.Fragment>
  );
};
export default NegativeScenarioErros;
